<template>
  <div class="container">
    <div class="top-wrapper">
      <img src="../../assets/images/a.png" alt="" />
      <!-- <div class="desc">为了给您定制专属学习规划，请您抽出 2～3 分钟，登</div>
      <div class="desc">记您孩子的课程需求，我们将会在 48 小时内安排班主</div>
      <div class="desc">任老师联系您～</div> -->
    </div>
    <div class="desc-wrapper">
      <img class="left-img" src="../../assets/images/line.png" alt="" />
      <img class="right-img" src="../../assets/images/line.png" alt="" />
      <div class="top">
        <div class="title-wrapper">咱们孩子现在校内在读几年级？</div>
      </div>
      <div class="grade-wrapper">
        <div class="student-title one">小学</div>
        <div class="list">
          <div
            @click="handleClcikGrade(item.id)"
            class="item-wrapper"
            :class="{ active: gradeId === item.id }"
            v-for="(item, index) in primaryList"
            :key="item.id"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="student-title two">初中</div>
        <div class="list">
          <div
            @click="handleClcikGrade(item.id)"
            class="item-wrapper"
            :class="{ active: gradeId === item.id }"
            v-for="(item, index) in juniorList"
            :key="item.id"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="student-title two">高中</div>
        <div class="list">
          <div
            @click="handleClcikGrade(item.id)"
            :class="{ active: gradeId === item.id }"
            class="item-wrapper"
            v-for="(item, index) in highList"
            :key="item.id"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="desc-wrapper" v-if="subjectList.length">
      <img class="left-img" src="../../assets/images/line.png" alt="" />
      <img class="right-img" src="../../assets/images/line.png" alt="" />
      <div class="top">
        <div class="title-wrapper">您打算给孩子报哪几项学科的课程？</div>
      </div>
      <div class="small-title">（可多选）</div>
      <div class="subject-list">
        <div
          class="publish-item"
          v-for="(item, index) in subjectList"
          :key="item.id"
        >
          <div
            @click="handleClcikSubject(item.id)"
            class="item-wrapper"
            :class="{ active: subjectIdList.includes(item.id) }"
          >
            {{ item.name }}
          </div>
          <img
            v-if="subjectIdList.includes(item.id)"
            class="select"
            src="../../assets/images/select.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="desc-wrapper" v-if="!idStatus">
      <img class="left-img" src="../../assets/images/line.png" alt="" />
      <img class="right-img" src="../../assets/images/line.png" alt="" />
      <div class="tel-title">您孩子的名字？</div>
      <div class="input-wrapper input-wrapper-one">
        <input
          v-model="studentName"
          class="tel-text"
          type="text"
          placeholder="请输入名字"
        />
      </div>
    </div>
    <div class="desc-wrapper">
      <img class="left-img" src="../../assets/images/line.png" alt="" />
      <img class="right-img" src="../../assets/images/line.png" alt="" />
      <div class="tel-title">
        如需班主任老师给您专业解答，您可以选择留下【手机号】。以便班主任及时联系您～
      </div>
      <div class="input-wrapper">
        <input
          v-model="phone"
          class="tel-text"
          type="text"
          placeholder="请输入联系方式"
        />
      </div>
      <div class="button-wrapper">
        <van-button @click="handleSubmit">提交</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { primaryList, juniorList, highList, subjectaObj } from "./config";
import { recordSource, submitForm } from "../../httpServer/api";

export default {
  data() {
    return {
      id: null,
      primaryList,
      juniorList,
      highList,
      subjectList: [],
      gradeId: null,
      subjectIdList: [],
      phone: "",
      studentName: "",
    };
  },
  async created() {
    this.id = Number(this.$route.params.id);
    await recordSource(this.$route.params.id);
  },
  computed: {
    idStatus() {
      return this.id === 2 || this.id === 7 || this.id === 8 || this.id === 9;
    },
  },
  watch: {
    gradeId: {
      immediate: true,
      handler(newValue, oldValue) {
        this.subjectIdList = [];
        switch (true) {
          case newValue >= 1 && newValue <= 7:
            this.subjectList = subjectaObj["primary"];
            break;
          case newValue === 8:
            this.subjectList = subjectaObj["juniorOne"];
            break;
          case newValue === 9:
            this.subjectList = subjectaObj["juniorTwo"];
            break;
          case newValue === 10:
            this.subjectList = subjectaObj["juniorThree"];
            break;
          case newValue >= 11 && newValue <= 13:
            this.subjectList = subjectaObj["high"];
            break;
          default:
            this.subjectList = [];
        }
      },
    },
  },
  methods: {
    handleClcikGrade(id) {
      if (this.gradeId === id) return;
      this.gradeId = id;
      this.subjectIdList = [];
    },
    handleClcikSubject(id) {
      if (this.subjectIdList.includes(id)) {
        this.subjectIdList.splice(this.subjectIdList.indexOf(id), 1);
      } else {
        this.subjectIdList.push(id);
      }
    },
    async handleSubmit() {
      const obj = {};
      obj.studentName = this.studentName;
      obj.course = this.subjectIdList;
      obj.phone = this.phone;
      obj.grade = [];
      if (this.gradeId) {
        obj.grade.push(this.gradeId);
      }
      let reg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
      if (!this.idStatus) {
        // 非app渠道
        if (!obj.grade.length) return Toast("回答完所有问题才能提交哦~");
        if (!obj.course.length) return Toast("回答完所有问题才能提交哦~");
        if (!obj.studentName) return Toast("回答完所有问题才能提交哦~");
        if (!reg.test(obj.phone)) return Toast("请输入正确的手机号～");
      } else {
        // app渠道
        if (!obj.grade.length) return Toast("回答完所有问题才能提交哦~");
        if (!obj.course.length) return Toast("回答完所有问题才能提交哦~");
        if (obj.phone && !reg.test(obj.phone))
          return Toast("请输入正确的手机号～");
      }
      obj.channel = Number(this.$route.params.id);
      const res = await submitForm(obj);
      if (res.code === 0) {
        this.$router.push({
          path: "/success",
          query: {
            id: this.$route.params.id,
          },
        });
      } else {
        console.log(res);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@function px2vw($px) {
  @return $px * 100vw / 375;
}
.container {
  width: 100%;
  height: 100%;
  padding: px2vw(202) px2vw(13) px2vw(21);
  background-image: url("../../assets/images/bg.png");
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-color: #fff4ee;
}
.top-wrapper {
  margin: 0 auto px2vw(15);
  padding: px2vw(15) px2vw(18) px2vw(25);
  background: #ffffff;
  box-shadow: 0px px2vw(5) px2vw(5) 0px rgba(0, 0, 0, 0.05);
  border-radius: px2vw(13);
  img {
    display: block;
    width: 100%;
  }
}
.desc-wrapper {
  margin: 0 auto px2vw(15);
  padding: px2vw(15) px2vw(16) px2vw(26);
  background: #ffffff;
  box-shadow: 0px px2vw(5) px2vw(5) 0px rgba(0, 0, 0, 0.05);
  border-radius: px2vw(13);
  position: relative;
  .desc {
    font-size: px2vw(13);
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #680000;
    line-height: px2vw(30);
    border-bottom: px2vw(0.5) solid rgba(212, 67, 77, 0.3);
  }
  .left-img {
    width: px2vw(12);
    height: px2vw(55);
    position: absolute;
    top: px2vw(-35);
    left: px2vw(8);
  }
  .right-img {
    width: px2vw(12);
    height: px2vw(55);
    position: absolute;
    top: px2vw(-35);
    right: px2vw(8);
  }
  .top {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .small-title {
    text-align: center;
    font-size: px2vw(11);
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #680000;
    margin: px2vw(5) 0 px2vw(15);
  }
  .subject-list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .publish-item {
      position: relative;
      margin-bottom: 15px;
      width: px2vw(97);
      height: px2vw(32);
      .item-wrapper {
        width: px2vw(97);
        height: px2vw(32);
        line-height: px2vw(32);
        background: #f1f1f1;
        border-radius: px2vw(5);
        text-align: center;
        font-size: px2vw(13);
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        letter-spacing: 1px;
      }
      .active {
        width: px2vw(97);
        height: px2vw(32);
        line-height: px2vw(30);
        border: px2vw(1) solid #ba0000;
        background: #ffffff;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ba0000;
        box-sizing: border-box;
      }
      .select {
        width: px2vw(18);
        height: px2vw(17);
        display: block;
        position: absolute;
        top: 0;
        right: 0;
      }
    }
  }
  .subject-list:after {
    content: "";
    width: 30%;
  }
  .grade-wrapper {
    .student-title {
      height: px2vw(15);
      font-size: px2vw(15);
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: px2vw(15);
      margin-bottom: px2vw(15);
    }
    .one {
      margin-top: px2vw(22);
    }
    .two {
      margin-top: px2vw(7);
    }
    .list {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .item-wrapper {
        width: px2vw(97);
        height: px2vw(32);
        line-height: px2vw(32);
        background: #f1f1f1;
        border-radius: px2vw(5);
        text-align: center;
        font-size: px2vw(13);
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        letter-spacing: 1px;
        margin-bottom: 15px;
      }
      .active {
        width: px2vw(97);
        height: px2vw(32);
        line-height: px2vw(30);
        border: px2vw(1) solid #ba0000;
        background: #ffffff;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ba0000;
        box-sizing: border-box;
      }
    }
  }
  .title-wrapper {
    display: inline-block;
    background-image: url("../../assets/images/title-bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    padding: 0 px2vw(9) 0 px2vw(24);
    font-size: px2vw(15);
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #680000;
    line-height: px2vw(25);
    margin: 0 auto;
  }
  .tel-title {
    // width: 309px;
    max-height: px2vw(40);
    font-size: px2vw(13);
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #680000;
    line-height: px2vw(20);
    margin: px2vw(2) 0 px2vw(10);
  }
  .input-wrapper {
    width: 100%;
    display: flex;
    margin-bottom: px2vw(25);
    .tel-text {
      padding: 0 px2vw(15);
      flex: 1;
      height: px2vw(32);
      border: none;
      background: #f1f1f1;
      border-radius: px2vw(5);
    }
  }
  .input-wrapper-one {
    margin-bottom: 0;
  }
  .button-wrapper {
    display: flex;
    justify-content: center;
    .van-button {
      width: px2vw(288);
      height: px2vw(48);
      background: #ba0000;
      border-radius: px2vw(24);
      font-size: px2vw(18);
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }
  }
}
</style>
